<!--
 * @Author: Gaho
 * @Date: 2024-03-01 09:42:48
 * @LastEditors: Merlin
 * @LastEditTime: 2025-07-07 14:08:19
 * @Description: 当前组件名： <CasinoHistoryGameContent 
-->
<template>
    <component 
        :is="component"
        :history="history" 
        :fnScrollMove="fnScrollMove" 
        :key="history?._id" 
        v-if="history?._id"
        @handleSelectItem="handleSelectItem"
        :currentIndex="currentIndex"
    />
    <div v-else
        class="loading-box"
    >
        <IconSvgUse
            size="30px"
            use="icon-loading"
            class="spinning-infinite" 
        />
    </div>
</template>

<script lang="ts" setup>
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import { useGameIdListStore } from '@/stores/cansino/gameIdList';
// ↑ 其它导入 
// ↓ 各个游戏结果组件   
import SpaceDice from './SpaceDice.vue';
import Dice from './Dice.vue';
import Plinko from './Plinko.vue';
import Crash from './Crash.vue';
import Ring from './Ring.vue';
import Cryptos from './Cryptos.vue';
import Triple from './Triple.vue';
import Limbo from './Limbo.vue';
import CoinFlip from './CoinFlip.vue';
import Tower from './Tower.vue';
import Hilo from './Hilo.vue';
import Roulette from './Roulette.vue';
import Mines from './Mines.vue';
import Keno from './Keno.vue';
import Pharaoh from './Pharaoh.vue';
import CorgiWild from './CorgiWild.vue';
import Blackjack from './Blackjack.vue';
import Circle from './Circle.vue'
import Stairs from './Stairs.vue'; 
import RedPacket from './RedPacket.vue'; 
import NiuNiu from './NiuNiu.vue';
import Goldenflower from './Goldenflower.vue'; 

const gameIdListStore = useGameIdListStore();
const component = ref(null);
const gameName = ref('');
const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
    fnScrollMove: { 
        type: Function,
    },
    handleSelectItem: { // coinflip游戏使用
        type: Function,
    },
    currentIndex: {
        type: Number,
        default: 0
    },
    gameDropValue:{
        type: String,
        default: '', 
    },
});

const oGameMap = {
    'spacedice': markRaw(SpaceDice),
    'dice': markRaw(Dice),
    'plinko': markRaw(Plinko),
    'crash': markRaw(Crash),
    'ring': markRaw(Ring),
    'cryptos': markRaw(Cryptos),
    'triple': markRaw(Triple),
    'limbo': markRaw(Limbo),
    'coinflip': markRaw(CoinFlip),
    'tower': markRaw(Tower),
    'mines': markRaw(Mines),
    'stairs': markRaw(Stairs),
    'circle': markRaw(Circle),
    'roulette': markRaw(Roulette),
    'hilo': markRaw(Hilo),
    'keno': markRaw(Keno),
    'redpacket': markRaw(RedPacket),
    'niuniu': markRaw(NiuNiu),
    'blackjack': markRaw(Blackjack),
    'goldenFlower': markRaw(Goldenflower),
    // ----- ↓ 最后 corgi 系列 ↓ ---------------------------------------
    'corgipharaoh': markRaw(Pharaoh),
    'corgiwild': markRaw(CorgiWild),
};

watch(() => props.history, (newVal, oldVal) => {
    const todo = (
        import.meta.client 
        && newVal?.['_id']
        && (JSON.stringify(oldVal) !== JSON.stringify(newVal))
    );
    if (!todo) return;
    // 无论游戏从哪里打开，游戏名称都从 props.gameDropValue 取值
    // 从Account页面tab=game-history打开下注详情，则通过地址栏参数查询游戏名称
    gameName.value = props.gameDropValue; 
    gameName.value ||= gameIdListStore.gameIdNameList.find(game => {
        return game.id === newVal?.game?.id;
    })?.name;
    component.value = oGameMap[gameName.value];
    if (!component.value){
        console.error('注大意：未能匹配游戏对应的组件，游戏名与历史数据如下：\n', gameName.value, deepCopy(newVal)); 
    }
}, {
    immediate: true,
});

</script>


<style scoped lang="scss">
.loading-box{
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    .spinning-infinite {
        opacity: 0.6;
        animation: rotateInfinite 1.5s linear infinite;
    }
}


@keyframes rotateInfinite {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
